import {
  FETCH_DELIVERY_TIME,
  DELIVERY_TIME_LOADING,
} from "../actions/actionTypes";
import moment from "moment";

const initialState = {
  asap: null,
  scheduled: null,
  pickup: null,

  expected_date: "",
  expected_start: "",
  expected_end: "",
  type: null,
  isPickup: false,

  loading: false,

  drawerOpen: false,
  didOpen: false,

  showCheckCart: false,
};

export default (state = initialState, { type, payload }) => {
  let expected_date = null;
  let expected_start = null;
  let expected_end = null;
  switch (type) {
    case FETCH_DELIVERY_TIME:
      expected_date = state.expected_date;
      expected_start = state.expected_start;
      expected_end = state.expected_end;
      let newType = state.type;

      if (
        expected_date &&
        expected_start &&
        expected_end &&
        state.type !== "asap"
      ) {
        let slotsToSearchIn = null;
        if (!!payload.pickup && Object.keys(payload.pickup).length > 0) {
          slotsToSearchIn = payload.pickup;
        } else if (
          !!payload.scheduled &&
          Object.keys(payload.scheduled).length > 0
        ) {
          slotsToSearchIn = payload.scheduled;
        }

        if (
          slotsToSearchIn &&
          Object.keys(slotsToSearchIn).includes(expected_date) &&
          slotsToSearchIn[expected_date].active == true
        ) {
          if (
            slotsToSearchIn[expected_date]["slots"].find(
              (slot) => slot.start == expected_start && slot.end == expected_end
            )
          ) {
            // let asap = state.asap;
            // if (payload.reset_asap) {
            //   asap = null;
            // }
            // if (payload.asap) asap = payload.asap;
            return {
              ...state,
              ...payload,
              expected_date: expected_date,
              expected_start: expected_start,
              expected_end: expected_end,
              didOpen: false,
            };
          }
        }
      }
      if (
        !!payload.pickup &&
        Object.keys(payload.pickup).length > 0 &&
        !payload.asap
      ) {
        expected_date = Object.keys(payload.pickup).filter(
          (date) => payload.pickup[date].active == true
        )[0];
        expected_start = payload.pickup[expected_date]["slots"][0]["start"];
        expected_end = payload.pickup[expected_date]["slots"][0]["end"];
      } else if (!payload.pickup || payload.asap) {
        if (payload.asap) {
          expected_date = moment(payload.asap.date, "YYYY-MM-DD").format(
            "YYYY-MM-DD"
          );
          expected_start = payload.asap.start;
          expected_end = payload.asap.end;
          newType = "asap";
        } else if (
          !!payload.scheduled &&
          Object.keys(payload.scheduled).length > 0
        ) {
          expected_date = Object.keys(payload.scheduled).filter(
            (date) => payload.scheduled[date].active == true
          )[0];
          expected_start =
            payload.scheduled[expected_date]["slots"][0]["start"];
          expected_end = payload.scheduled[expected_date]["slots"][0]["end"];
        }
      }

      if (!newType) {
        if (payload.asap) newType = "asap";
        else newType = "scheduled";
      } else if (newType == "asap" && !payload.asap) newType = "scheduled";

      return {
        ...state,
        ...payload,
        type: newType,
        isPickup: payload.isPickup,
        expected_date: expected_date,
        expected_start: expected_start,
        expected_end: expected_end,
        didOpen: false,
      };
    case DELIVERY_TIME_LOADING:
      return { ...state, loading: payload };

    case "HANDLE_DELIVERY_TYPE_CHANGE":
      const source = state.scheduled || state.pickup;
      if (payload == "scheduled") {
        expected_date = Object.keys(source).filter(
          (date) => source[date].active == true
        )[0];
        expected_start = source[expected_date]["slots"][0]["start"];
        expected_end = source[expected_date]["slots"][0]["end"];
      } else if (payload == "asap" && state.asap) {
        expected_date = moment(state.asap.date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        expected_start = state.asap.start;
        expected_end = state.asap.end;
      }
      return {
        ...state,
        type: payload,
        expected_date: expected_date,
        expected_start: expected_start,
        expected_end: expected_end,
      };

    case "HANDLE_DELIVERY_DATE_CHANGE":
      if (state.isPickup && state.pickup) {
        expected_date = payload;
        expected_start = state.pickup[expected_date]["slots"][0]["start"];
        expected_end = state.pickup[expected_date]["slots"][0]["end"];
      } else if (state.scheduled) {
        expected_date = payload;
        expected_start = state.scheduled[expected_date]["slots"][0]["start"];
        expected_end = state.scheduled[expected_date]["slots"][0]["end"];
      }
      return {
        ...state,
        expected_date: expected_date,
        expected_start: expected_start,
        expected_end: expected_end,
      };

    case "HANDLE_DELIVERY_TIME_CHANGE":
      expected_start = payload.split(" - ")[0];
      expected_end = payload.split(" - ")[1];
      return {
        ...state,
        expected_start: expected_start,
        expected_end: expected_end,
      };

    case "SET_DELIVERY_TIME_DRAWER":
      return {
        ...state,
        drawerOpen: payload,
        didOpen: payload == true ? true : state.didOpen,
      };

    case "SET_DELIVERY_TIME_DID_OPEN":
      return { ...state, didOpen: payload };

    case "RESET_DELIVERY_TIME":
      return {
        ...initialState,
      };
    case "SHOW_CHECK_CART":
      return { ...state, showCheckCart: true };
    default:
      return state;
  }
};
